module.exports = __webpack_public_path__ + "img/fbb5f9b.jpg";